module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "small"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "assets/img/logo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "menu-toggle active",
    attrs: {
      "id": "menu-toggle"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('div', {
    staticClass: "kartyarendszer"
  }, [_c('h1', [_c('i', {
    staticClass: "kricon fa fa-id-card-o"
  }), _vm._v("KMR"), _c('span', [_vm._v(" - Kártya Menedzsment Rendszer")])]), _vm._v(" "), _c('p', [_vm._v("A Széchenyi István Egyetem kártya menedzsment felülete.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-424cef4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tpl_header.vue
// module id = 53
// module chunks = 0